export class IGlinkTotals {
  ZbirTrajanjaSec = 0;
  OsnovnaCena = '0.00';
  IznosKorekcija = '0.00';
  IznosSaKorekcijama = '0.00';
  ZbirTrajanjaString = '00:00:00';
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/glink-maska-16/glink-totals.ts